export { default } from './InfiniteTabs';
